import { useState } from "react";
import { useRouter } from "next/router";
import cls from "classnames";
import * as Track from "@qoohoo/common/utils/analytics/track";

import Spinner from "@qoohoo/common/library/loader/Spinner";
import { link } from "@qoohoo/common/constants/analytics";
import getCurrentPageViewByUrl from "../hooks/getCurrentPageViewByUrl";
import { addTagsInRecording } from "@qoohoo/common/utils/analytics/clarity";

const IOSDeepLink = ({ deepLink, isButton = false, onClick, ...props }) => {
  const [isLoading, setIsLoading] = useState(false);
  const current_screen = getCurrentPageViewByUrl();

  const router = useRouter();

  function redirectToApp() {
    let intentLink = "qoohoo.intent";

    if (deepLink) {
      intentLink += deepLink.replace(/^https?/, "");
    } else {
      intentLink += "://";
    }

    window.location.replace(intentLink);
  }

  function redirectToGetTheAppPage() {
    setTimeout(function () {
      const redirectTo = deepLink;
      const encodedRedirectTo = encodeURIComponent(redirectTo);
      const redirectPath = `/get-the-app/?redirect_to=${encodedRedirectTo}`;
      router.push(redirectPath);
      setIsLoading(false);
    }, 1500);
  }

  function handleOpenInApp(e) {
    if (typeof onClick == "function") {
      onClick(e);
    }

    addTagsInRecording({
      open_in_app: true,
      platform: "ios",
    });

    Track.linkClick(link.open_in_app, {
      url: deepLink,
      platform_target: "ios",
      current_screen,
    });

    setIsLoading(true);

    redirectToApp(e);

    redirectToGetTheAppPage();
  }

  return (
    <a
      className={cls(
        isButton
          ? "text-sm md:text-lg font-semibold font-inter outline-none flex w-full px-6 h-[52px] rounded-full bg-[#5754F5] justify-center items-center hover:opacity-90"
          : "underline"
      )}
      onClick={handleOpenInApp}
      {...props}
    >
      {isLoading ? <Spinner size="xs" /> : "Open in App"}
    </a>
  );
};

export default IOSDeepLink;
